import { PopupButtonType, PopupIconType, showPopup, useURL } from "@kalyzee/kast-web-sdk/web-components";
import { createRef } from "react";
import { MessagingBridgeManagerSlaveContextProvider } from "../../../contexts/messagingBridgeManagerProvider";
import { getSlaveQuery, NavigateSlaveQuery } from "../../../helpers/navigation";
import { useSettings } from "../../../hooks/settings";
import RouteContainer, { RouteContainerProps } from "./RouteContainer";

import styles from "./SlaveRouteContainer.module.css";

export const SlaveRouteContainer = ({ element, children }: RouteContainerProps) => {
  const url = useURL();
  const [settings, setSettings] = useSettings();

  let enableWebsocket = settings.bridge?.slave?.enableWebsocket ?? false;
  let websocketEndpoint = settings.bridge?.slave?.websocketEndpoint;
  const bridgeWebsocketEndpoint = getSlaveQuery(url.href, NavigateSlaveQuery.BRIDGE_WEBSOCKET_ENDPOINT);
  if (bridgeWebsocketEndpoint) {
    enableWebsocket = true;
    websocketEndpoint = bridgeWebsocketEndpoint;
  }
  let passwordPopupDisplaying = false;

  return (
    <MessagingBridgeManagerSlaveContextProvider
      options={{
        enableBroadcast: settings.bridge?.slave?.enableBroadcast ?? false,
        enableWebsocket,
        websocketEndpoint,
        password: settings.secret?.remotePassword ?? undefined,
      }}
      onMessagingBridgeManager={(manager) => {
        manager.addEventListener("unauthorized", (msg) => {
          const inputRef = createRef<HTMLInputElement>();
          const wrongPassword = msg.content.code === -2;
          const title = wrongPassword ? "Mot de passe invalide" : "Mot de passe requis";
          const message = wrongPassword
            ? "Le mot de passe pour se connecter à l'appareil distant est incorrect."
            : "Un mot de passe est nécessaire pour se connecter à l'appareil distant.";
          const showPasswordPopup = () => {
            if (passwordPopupDisplaying) return;
            passwordPopupDisplaying = true;
            showPopup({
              title,
              iconTitle: PopupIconType.INFO,
              content: (
                <div className={styles.popupPasswordContainer}>
                  <div className={styles.popupPasswordTitle}>{message}</div>
                  <div className={styles.popupPasswordDescription}>Saisissez le mot de passe:</div>
                  <input className={styles.popupPasswordInput} ref={inputRef} type="password" />
                </div>
              ),
              buttons: [{ type: PopupButtonType.VALIDATE, element: "Valider" /* TRANSLATION */ }],
              enableBackdropDismiss: false,
              enableCloseButton: false,
              onClose: () => {
                passwordPopupDisplaying = false;
                const password = inputRef.current?.value;
                if (!password) {
                  showPasswordPopup();
                  return;
                }
                setSettings({ secret: { remotePassword: password } }, { mergeWithExisting: true, save: true });
                window.location.reload();
              },
            });
          };
          showPasswordPopup();
        });
      }}
    >
      <RouteContainer element={element} children={children} />
    </MessagingBridgeManagerSlaveContextProvider>
  );
};

export default SlaveRouteContainer;
